<template lang="pug">
  v-container
    v-row
      v-col.text-center
        v-card.d-inline-block
          v-card-title.text-caption.text-center.justify-center Cagnotte
          v-card-text.text-h2 {{ $money(walletAmount) }}
    v-subheader.my-4 Saisissez le montant que vous souhaitez retirer
    v-form(
      v-model="form"
      @submit.prevent="$createOnClick({ onSubmitNative: onSubmit })")
      v-row
        v-col
          input-money(
            v-model="amount"
            autofocus
            :error-messages="errorMessages"
            filled
            label="Montant à retirer")
      v-row
        v-col
          input-money(
            v-model="amountForYako"
            filled
            :error-messages="errorMessagesYako"
            label="Reverser une partie du montant à Yako ?")
</template>

<script>
import { ref, toRefs, computed } from '@vue/composition-api'
import { page, injectRouteState } from '@iez/core'
import InputMoney from '@iez/components/inputs/money/'
import data from '@iez/lib/data/'
import router from '@iez/core/router/'

const route = {
  name: `ReceivedSupportsAmount`,
  path: `/received-supports-amount`
}

export default {
  ...route,

  components: {
    InputMoney
  },

  setup () {
    const routeStateReceivedSupports = injectRouteState({
      name: `ReceivedSupports`
    })

    const form = ref(false)
    const amount = ref(null)
    const amountForYako = ref(0)
    const errorMessages = computed(
      () => amount.value + amountForYako.value < 500
        ? `Le montant doit être supérieur à 5,00€.`
        : amount.value + amountForYako.value > routeStateReceivedSupports.walletAmount
          ? `Vous ne disposez pas des fonds nécessaires.`
          : undefined
    )
    const errorMessagesYako = computed(
      () => amount.value + amountForYako.value > routeStateReceivedSupports.walletAmount
        ? `Vous ne disposez pas des fonds nécessaires.`
        : undefined
    )

    const onSubmit = () => {
      data.set({
        root: `requestsToWithdraw`,
        items: [{
          iban: routeStateReceivedSupports.iban,
          bic: routeStateReceivedSupports.bic,
          name: routeStateReceivedSupports.name,
          surname: routeStateReceivedSupports.surname,
          remember: routeStateReceivedSupports.remember,
          amount: amount.value,
          amountForYako: amountForYako.value,
          associationId: routeStateReceivedSupports.associationId
        }],
        fields: [
          `id`
        ]
      })
      page.blockingDialog.set({
        title: `Demande confirmée`,
        content: `Votre demande a bien prise en compte. Yako va traiter votre demande le plus rapidement possible.`,
        action1: {
          label: `OK`,
          onClick: () => {
            page.blockingDialog.unset()
          }
        }
      })
      router.back()
      router.back()
    }

    page.topBar.set({
      title: `Retrait d'argent`
    })

    page.bottomAction.set(
      () => form.value
        ? {
          action: {
            label: `Valider la demande`,
            onClick: onSubmit
          }
        } : null
    )

    return {
      amount,
      form,
      onSubmit,
      amountForYako,
      errorMessages,
      errorMessagesYako,
      ...toRefs(routeStateReceivedSupports)
    }
  }
}
</script>
